import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChatIcon } from "../../assets/iconComponents/ChatIcon";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { StyledButton } from "../shared/Button/Button.styles";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  DetailedResultsButtonTextWrapper,
  DetailedResultsExpertWrapper,
} from "./DetailedResults.styles";

export const DetailedResultsExpert: React.FC<{ contactUs?: boolean }> = ({
  contactUs,
}) => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <DetailedResultsExpertWrapper deviceType={deviceType}>
      <div>
        <ChatIcon />
      </div>
      <div>
        {GetTypographyContent({
          content: contactUs
            ? t("results.expert.scheduleTitle")
            : t("results.expert.discussTitle"),
          size: "xlarge",
          textColor: "greyMedium",
          isBold: true,
        })}
      </div>
      <div>
        {GetTypographyContent({
          content: contactUs
            ? t("results.expert.scheduleBody")
            : t("results.expert.discussBody"),
          size: "medium",
          textColor: "greyMedium",
        })}
      </div>
      <StyledButton
        variant="outlined"
        size="small"
        $backgroundColor="white"
        $textColor="redMedium"
        onClick={() => history.push("./scheduling")}
      >
        <DetailedResultsButtonTextWrapper>
          {GetTypographyContent({
            content: t("results.actions.bookConsultation"),
            size: "medium",
            textColor: "redMedium",
            isCaps: true,
            isBold: false,
          })}
        </DetailedResultsButtonTextWrapper>
      </StyledButton>
    </DetailedResultsExpertWrapper>
  );
};
